'use client'
import NextLink from 'next/link'
import { twMerge } from 'tailwind-merge'
import React, { useState } from 'react'
import { BrandLogo } from '@/components/icons'
import {
  BaseModal,
  SupportRequestModalContent,
} from '@/components/ui/common/modal'
import { SupportModalSourceType } from '@/types/firebase/ai-agent-chat-conversation'

interface NavigationItem {
  name: string
  href: string
}

interface FooterProps {
  className?: string
  textColor?: string
}

const navigation: NavigationItem[] = [
  {
    name: 'Courses',
    href: '/courses',
  },
  {
    name: 'Pricing',
    href: '/pricing',
  },
  {
    name: 'About',
    href: '/about',
  },
  // {
  //   name: 'Teach on ExamSolutions',
  //   href: '/tutor-onboarding',
  // },
  {
    name: 'Support',
    href: '/',
  },
]
export const AirMathLogo: React.FC = () => {
  return (
    <svg
      width="204"
      height="25"
      viewBox="0 0 204 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.4083 23.8151L18.2506 18.8027H8.5245L6.36682 23.8151H0.856445L10.8813 0.611816H15.8938L25.9187 23.8151H20.4083ZM13.4042 7.51638L10.483 14.255H16.2921L13.4042 7.51638Z"
        fill="#FF692E"
      />
      <path
        d="M28.6114 0.611816H33.7898V23.8151H28.6114V0.611816Z"
        fill="#FF692E"
      />
      <path
        d="M58.3251 8.31306C58.3251 12.0309 56.8534 14.432 53.9101 15.5164L59.7856 23.8151H53.4122L48.267 16.4126H44.6819V23.8151H39.5035V0.611816H48.3002C51.9074 0.611816 54.4744 1.22039 56.0014 2.43754C57.5505 3.65469 58.3251 5.6132 58.3251 8.31306ZM48.4661 11.9313C50.2365 11.9313 51.4426 11.6436 52.0844 11.0682C52.7262 10.4929 53.0471 9.58554 53.0471 8.34626C53.0471 7.08485 52.7151 6.22178 52.0512 5.75705C51.3873 5.29232 50.2255 5.05995 48.5657 5.05995H44.6819V11.9313H48.4661Z"
        fill="#FF692E"
      />
      <path
        d="M106.959 9.20968L100.685 21.8902H97.598L91.3574 9.20968V23.8155H86.179V0.612174H93.1831L99.1582 13.3591L105.167 0.612174H112.137V23.8155H106.959V9.20968Z"
        fill="#FF692E"
      />
      <path
        d="M134.381 23.8155L132.224 18.803H122.498L120.34 23.8155H114.83L124.855 0.612174H129.867L139.892 23.8155H134.381ZM127.377 7.51674L124.456 14.2553H130.265L127.377 7.51674Z"
        fill="#FF692E"
      />
      <path
        d="M150.725 5.0935V23.8155H145.546V5.0935H138.974V0.612174H157.297V5.0935H150.725Z"
        fill="#FF692E"
      />
      <path
        d="M175.501 0.612174H180.68V23.8155H175.501V14.6869H166.273V23.8155H161.095V0.612174H166.273V10.3051H175.501V0.612174Z"
        fill="#FF692E"
      />
      <path
        d="M193.849 4.62877C192.986 4.62877 192.3 4.83901 191.791 5.25948C191.304 5.65782 191.06 6.2 191.06 6.88603C191.06 7.54993 191.359 8.08105 191.957 8.4794C192.576 8.87774 193.982 9.35353 196.172 9.90678C198.385 10.4379 200.101 11.2456 201.318 12.33C202.535 13.4144 203.143 14.9967 203.143 17.0769C203.143 19.1571 202.358 20.8501 200.787 22.1557C199.237 23.4393 197.19 24.0811 194.646 24.0811C190.972 24.0811 187.663 22.7201 184.72 19.9981L187.807 16.2138C190.308 18.4047 192.621 19.5001 194.745 19.5001C195.697 19.5001 196.438 19.301 196.969 18.9026C197.522 18.4822 197.799 17.9289 197.799 17.2429C197.799 16.5347 197.511 15.9815 196.936 15.5831C196.361 15.1627 195.221 14.7422 193.517 14.3217C190.817 13.6799 188.836 12.8501 187.575 11.8321C186.336 10.792 185.716 9.17649 185.716 6.98562C185.716 4.77262 186.502 3.06861 188.073 1.87359C189.666 0.678565 191.647 0.0810547 194.015 0.0810547C195.564 0.0810547 197.113 0.346615 198.662 0.877735C200.211 1.40885 201.561 2.16128 202.712 3.135L200.089 6.91923C198.076 5.39226 195.995 4.62877 193.849 4.62877Z"
        fill="#FF692E"
      />
      <path
        d="M71.1988 15.2263C70.6455 14.6509 70.3689 13.9538 70.3689 13.135C70.3689 12.3162 70.6455 11.6302 71.1988 11.0769C71.7742 10.5016 72.4712 10.2139 73.2901 10.2139C74.1089 10.2139 74.7949 10.5016 75.3482 11.0769C75.9235 11.6302 76.2112 12.3162 76.2112 13.135C76.2112 13.9538 75.9235 14.6509 75.3482 15.2263C74.7949 15.7796 74.1089 16.0562 73.2901 16.0562C72.4712 16.0562 71.7742 15.7796 71.1988 15.2263Z"
        fill="#FF692E"
      />
    </svg>
  )
}

const Footer: React.FC<FooterProps> = ({ className = '', textColor = '' }) => {
  const [requestToSupport, setRequestToSupport] = useState(false)

  const date = new Date()
  return (
    <>
      <div className={twMerge('bg-[#ffffff80]', className)}>
        <div className="p-2 md:px-4 md:py-5 lg:px-8 mx-auto max-w-7xl sm:px-6 sm:py-7 md:justify-start relative bottom-0 mt-[2px] ">
          <div className="flex flex-shrink-0 items-center justify-center px-4">
            <BrandLogo />
          </div>
          <div className="flex justify-center">
            {navigation.map((res, i) => {
              return res.name === 'Support' ? (
                <div
                  onClick={() => setRequestToSupport(true)}
                  key={i + 'nav'}
                  className={twMerge(
                    'mx-2 md:pt-[30px] py-[10px] text-center text-sm md:text-base text-cgray-600 md:pb-[40px] cursor-pointer',
                    textColor,
                  )}
                >
                  {res.name}
                </div>
              ) : (
                <div
                  key={i + 'nav'}
                  className={twMerge(
                    'mx-2 md:pt-[30px] py-[10px] text-center text-sm md:text-base text-cgray-600 md:pb-[40px]',
                    textColor,
                  )}
                >
                  <NextLink href={res.href}>{res.name}</NextLink>
                </div>
              )
            })}
          </div>

          {/* Divider */}
          <div
            id="divider"
            className="h-[1px] w-full mt-2 bg-gray-300 self-center"
          ></div>

          <div className="w-full flex flex-col items-center gap-4 lg:grid lg:grid-cols-3 lg:gap-1 pt-4 md:pt-[30px]">
            {/* All Rights Reserved */}
            <div className="text-center lg:text-left lg:w-auto w-full">
              <p
                className={twMerge(
                  'text-[16px] text-[#475467] lg:text-nowrap',
                  textColor,
                )}
              >
                © {date ? date.getFullYear() : '2023'} ExamSolutions. All rights
                reserved.
              </p>
            </div>

            {/* TOS links */}
            <div className="w-full flex justify-center gap-2">
              <div className="text-center">
                <div
                  className={twMerge('text-[16px] text-[#475467]', textColor)}
                >
                  <NextLink href="/terms-conditions">Terms</NextLink>
                </div>
              </div>
              <div className="text-center mt-auto">
                <div
                  className={twMerge('text-[16px] text-[#475467]', textColor)}
                >
                  <NextLink href="/privacy-policy">Privacy</NextLink>
                </div>
              </div>
            </div>

            {/* BuildApps Link */}
            <div className="w-full text-center lg:flex lg:justify-end">
              <p
                className={twMerge(
                  'text-[16px] text-[#475467] lg:text-nowrap',
                  textColor,
                )}
              >
                {'Developed by '}
                <NextLink
                  href="https://buildapps.pro/"
                  target="_blank"
                  className="underline"
                >
                  {'BuildApps'}
                </NextLink>
              </p>
            </div>
          </div>
        </div>
      </div>

      <BaseModal
        isOpen={requestToSupport}
        onClose={() => setRequestToSupport(false)}
        content={
          <SupportRequestModalContent
            onClose={() => setRequestToSupport(false)}
            aiContext={null}
            supportModalSource={SupportModalSourceType.Footer}
          />
        }
        customZIndexClass="z-[200]"
        bodyAdditionalClassName="max-sm:w-full"
      />
    </>
  )
}

export default Footer
